import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

export const Title = styled.p`
    margin: 0;
    ${setFontVariant("h5", colorsPalettes.carbon[500])}
    margin-bottom: 8px;
`;

export const Chip = styled.p`
    margin: 0;
    ${setFontVariant("chip1", colorsPalettes.carbon[400])}
`;

export const InputTitle = styled.p`
    margin: 0;
    padding-bottom: 16px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
`;

export const InputBlockWrapper = styled(FlexColumn)`
    margin: 36px 0 32px 0;
`;

export const BodyText = styled(FlexRow)`
    align-items: center;
    gap: 4px;
    margin: 0;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
`;

export const SwitchWrapper = styled(FlexRow)`
    column-gap: 8px;
    margin-top: 12px;
    margin-bottom: 16px;
`;

export const SwitchLabel = styled.p`
    margin: 0;
    ${setFontVariant("body1", colorsPalettes.carbon[300])}
`;
